import { Strings } from "@constant";
import { ListAccountPage } from "@containers";
import { useEffect } from "react";

export const ListAccount = () => { 

  useEffect(() => {
    document.title = Strings.pageTitle("Account")
  })
  
  return (
    <>
      <ListAccountPage />
    </>
  );
};
